import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { costantValue } from '../../../services/forms-template.service';
import { NicaAnagraficaComponent } from '../../nica-anagrafica/nica-anagrafica.component';
import { NewNicaFormComponent } from '../../nica-form/new-nica-form.component';
import { alert, confirm } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-elenco-attivita',
  templateUrl: './elenco-attivita.component.html',
  styleUrls: ['./elenco-attivita.component.css']
})
export class ElencoAttivitaComponent implements OnInit {
  @ViewChild('elencoAttivita', { static: false }) elencoContatti!: NicaAnagraficaComponent;
  @ViewChild('newNicaForm', { static: false }) newNicaForm: NewNicaFormComponent;
  @Input() titolo: string = 'Elenco Attività';
  @Input() modifica: boolean = true
  @Input() aggiungi: boolean = true
  @Input() elimina: boolean = true
  @Input() service: string = 'elencoAttivitaGrid';
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>()
  @Input() api: string = 'diario';
  @Input() gridHeight: string = '600';
  @Input() costantValues: costantValue[] = []
  @Input() soloRicercaGlobale: boolean = false
  @Input() ricerca: boolean = false
  @Input() gridWidth
  @Input() isAdvancedXlsExportAvailable: boolean = false
  @Input() isExportDocxAvailable: boolean = true
  @Input() isExportExcelAvailable: boolean = true
  @Input() isExportPDFAvailable: boolean = true
  @Input() filter: string = '';
  @Input() dataInput: any;
  button = [
    {
      location: 'after',
      widget: 'dxButton',
      locateInMenu: 'never',
      stylingMode: 'text',
      text: 'Reset',
      event: 'reset-form',
   },
   {
      location: 'after',
      widget: 'dxButton',
      locateInMenu: 'never',
      stylingMode: 'text',
      text: 'Genera',
      event: 'applica-filtri',
   },
  ]
  constructor(
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  allEventAnagrafica(event: any) {
  }

  buttonEventAnagrafica(event) {
    console.log(event)
  }

  formButtonsEvent(selectedValue: any) {
    console.log('sono qui',selectedValue)
    if (selectedValue.name === 'reset-form') {
             confirm('Sei sicuro di voler resettare il form?', 'Reset Form?').then((x) => {
                if (!x) {
                   return;
                } else {
                   // Resetta tutti i dati del form
                   this.newNicaForm.dataSet = {}; // Pulisci tutti i dati del form
                   this.filter = '' // Pulisci tutti i valori del filtro
                   
                   this.elencoContatti.refresh() //aggiorno il contento della griglia di devExtreme
                   this.cdRef.detectChanges();
                   return alert('Form resettata con successo!', 'Form Resettato')
                }
             });
          } else if(selectedValue.name === 'applica-filtri'){
            this.newNicaForm.generaOdata().then((filtriApplicati) => {
               this.filter = ''
               const url = filtriApplicati;
               this.filter = this.filter + '?$filter=' + filtriApplicati
               this.elencoContatti.refresh()
               console.log(filtriApplicati);
               if (!url) {
                  return alert("Errore nella generazione dell'url, riprovare", 'Errore');
               }
               console.log('%cUrl Odata: ', 'background-color:yellow;color:black', url);
            });
          }
  }
}
